export default {"src":"/_next/static/media/icon_shoutout_owned.e682f6a7.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};